<template>
    <!--begin::Aside menu-->
    <div class="aside-menu flex-column-fluid">
        <!--begin::Aside Menu-->
        <div class="hover-scroll-overlay-y my-5 my-lg-5" id="kt_aside_menu_wrapper" data-kt-scroll="true" data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-height="auto" data-kt-scroll-dependencies="#kt_aside_logo, #kt_aside_footer" data-kt-scroll-wrappers="#kt_aside_menu" data-kt-scroll-offset="0">
            <!--begin::Menu-->
            <div class="menu menu-column menu-title-gray-800 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-500" id="#kt_aside_menu" data-kt-menu="true">
                <AsideMenuItem v-for="content in asideContent" :content="content"/>
            </div>
            <!--end::Menu-->
        </div>
        <!--end::Aside Menu-->
    </div>
    <div class="aside-footer flex-column-auto pt-5 pb-7 px-5" id="kt_aside_footer">
        <Link :href="this.route('logout')"
            method="post"
            as="button"
            type="button"
            class="btn btn-custom btn-primary w-100"
            data-bs-toggle="tooltip"
            data-bs-trigger="hover"
            data-bs-delay-show="5000"
            title="Sair do sistema"
            data-bs-original-title="Sair do sistema">
            <span class="btn-label">
                Sair do sistema
            </span>
            <span class="svg-icon btn-icon svg-icon-2">
              <i class="bi bi-power"></i>
            </span>
        </Link>
    </div>
    <!--end::Aside menu-->
</template>

<script>
import AsideMenuItem from "./AsideMenuItem";
import { Link } from "@inertiajs/inertia-vue3";
export default {
    components: {
        AsideMenuItem,
        Link
    },

    props: {
        asideContent: {
            required: true,
            type: Array,
        },
    }
}
</script>
